import { SimpleModal } from '../Modal';
import styles from './styles.module.scss';
import Avatar from '../Avatar';
import { useEffect, useState } from 'react';
import { InputMask } from '@react-input/mask';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { t } from 'i18next';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { FiAlertCircle } from 'react-icons/fi';
import { checkIncludeProfiles } from '../../utils/getAuthorityLevel';
import emptySvg from '../../images/empty.svg';

export default function PersonalDataModal({ show, setShow, currentUser, verifiedUser }) {
  const [step, setStep] = useState('review');
  const [seducData, setSeducData] = useState(null);
  const client = useClient();
  let session = localStorage.getItem('session');
  const isStudent = checkIncludeProfiles({ only: ['student'] });
  const isProfessor = checkIncludeProfiles({ only: ['professor'] });
  const verificated = localStorage.getItem('verificated');

  if (!isStudent && !isProfessor) return null;

  const form = useFormik({
    initialValues: {
      name: currentUser.name || '',
      cpf: currentUser.cpfCnpj || ''
    },
    validationSchema: yup.object({
      name: yup.string().required(t('warning.requiredField')),
      cpf: yup.string().required(t('warning.requiredField'))
    }),
    onSubmit: () => handleSubmit()
  });

  const getSeducClassrooms = async () => {
    const { data, error } = await client.fetch(`users/${currentUser.id}/seduc_classrooms`);
    if (error) {
      toast.error('Erro ao buscar turmas');
    }
    setSeducData(data.user);
  };

  const handleSubmit = async () => {
    if (!form.isValid) return;

    const payload = {
      name: form.values.name,
      cpfCnpj: form.values.cpf,
      'user-detail-attributes': {
        id: currentUser?.userDetail?.id,
        'cpf-verified': true
      }
    };

    const { data, error } = await client.mutate(`users/${currentUser.id}`, payload, { method: 'PUT' });
    if (error) {
      toast.error('Erro ao atualizar os dados cadastrais');
      return;
    } else {
      await getSeducClassrooms();
      setStep('details');
      session.userDetail.cpfVerified = true;
      session.cpfCnpj = form.values.cpf;
      session.name = form.values.name;
      localStorage.setItem('session', JSON.stringify(session));
      toast.success('Dados cadastrais revisados');
    }
  };

  const syncClassrooms = async () => {
    const { data, error } = await client.mutate(`users/${currentUser.id}/sync_seduc_classrooms`, {}, { method: 'POST' });
    if (error) {
      toast.error('Erro ao sincronizar turmas');
      return;
    }
  };

  const updateVerifications = async (key, value) => {
    const { data, error } = await client.mutate(
      `users/${currentUser.id}`,
      {
        'user-detail-attributes': {
          id: currentUser.userDetail.id,
          [key]: value
        }
      },
      { method: 'PUT' }
    );
    if (error) {
      toast.error('Erro ao atualizar verificação');
    }
  };

  useEffect(() => {
    if (verificated === 'false') return;
    if ((isStudent && verifiedUser?.['cpf-verified'] === true && verifiedUser?.['classroom-verified'] !== true) || (isProfessor && verifiedUser && verifiedUser?.['classroom-verified'] !== true)) {
      getSeducClassrooms().then(() => {
        setShow(true);
        setStep('details');
      });
    }
  }, [verifiedUser]);

  function formatCPF(value = '') {
    const digits = value.replace(/\D/g, '').slice(0, 11);

    return digits
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/(\d{3})\.(\d{3})\.(\d{3})(\d{1,2})$/, '$1.$2.$3-$4');
  }

  console.log(currentUser);

  return (
    <SimpleModal
      contentClassName="simple-modal active"
      show={show}
      onClose={() => setShow(false)}
      hideCloseButton
      closeOnOverlayClick={false}
    >
      {/* Etapa do formulário */}
      {step === 'review' && !isProfessor ? (
        <div style={{ width: '100%' }}>
          <h4
            className={styles.title}
            style={{ fontSize: '2rem', textAlign: 'center' }}
          >
            Revise seus dados cadastrais
          </h4>
          <p style={{ textAlign: 'center' }}>Atualize seus dados e clique no botão abaixo para salvar</p>
          <form onSubmit={form.handleSubmit}>
            <div className="form">
              <label
                className="form__label"
                htmlFor="name"
              >
                Nome completo
              </label>
              <input
                className="form__control"
                placeholder="Nome completo"
                id="name"
                name="name"
                type="text"
                value={form?.values?.name}
                onChange={e => form?.setFieldValue('name', e.target.value)}
              />
              {form?.touched?.name && form?.errors?.name && <span style={{ color: 'red' }}>{form?.errors?.name}</span>}

              <label
                htmlFor="cpf"
                className="form__label"
                style={{ marginTop: '1rem' }}
              >
                CPF
              </label>
              <input
                id="cpf"
                name="cpf"
                type="text"
                placeholder="000.000.000-00"
                maxLength={14}
                className="form__control"
                value={form.values.cpf}
                onChange={e => {
                  const formatted = formatCPF(e.target.value);
                  form.setFieldValue('cpf', formatted);
                }}
                onBlur={form.handleBlur}
              />
              {form?.touched?.cpf && form?.errors?.cpf && <span style={{ color: 'red' }}>{form?.errors?.cpf}</span>}
              <button
                type="submit"
                className="btn btn--primary btn--full u-mb-4 u-mt-3"
              >
                Salvar
              </button>
            </div>
          </form>
        </div>
      ) : (
        // Etapa de detalhamento
        <div className={styles.container}>
          <div>
            <h4 className={styles.title}>{seducData?.['iseduc-finded'] ? 'Ops! Seu cadastro foi alterado.' : 'CPF não encontrado'}</h4>
            <p>
              {seducData?.['iseduc-finded']
                ? `Por determinação da SEDUC-PI, os dados de todos os ${isProfessor ? 'professores' : 'alunos'} foram atualizados de acordo com o que consta no iSeduc (veja abaixo)`
                : `Seu cadastro não foi encontrado na base da SEDUC-PI (iSeduc).`}
            </p>
          </div>
          <div className={`${styles['user-card']} shadow-md`}>
            <div className={styles['user-avatar']}>
              {seducData && seducData?.['iseduc-finded'] ? (
                <Avatar
                  className={`avatar ${styles['user-avatar--img']}`}
                  src={seducData?.['image-url']}
                />
              ) : (
                <div className={`avatar ${styles['user-avatar--img']} ${styles['user-avatar--not-finded']}`}>?</div>
              )}
              <span className={`badge badge--primary badge--tiny ${styles['user-avatar--badge']}`}>{currentUser?.profileNames[0]}</span>
            </div>
            <div className={styles['user-data']}>
              <p className={styles['user-data-name']}>{seducData?.name}</p>
              <p className={seducData?.['iseduc-finded'] ? styles['user-data-text--disabled'] : styles['user-data-error']}>CPF: {seducData?.['iseduc-finded'] ? seducData?.['cpf-cnpj'] : 'não encontrado'}</p>
              <p className={styles['user-data-text--disabled']}>Email: {seducData?.email}</p>

              <div className={styles['user-academic-data']}>
                {seducData?.['iseduc-classrooms']?.length > 0 &&
                  seducData['iseduc-classrooms'].map(classroom => (
                    <div
                      key={classroom.id}
                      style={{ marginBottom: '1.5rem' }}
                    >
                      <p>Escola: {classroom.institution?.name}</p>
                      <p>Curso: {classroom.course?.title}</p>
                      <p>Turma: {classroom.title}</p>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div className={styles['institution-contact']}>
            <span className={`${styles['alert-icon']} ${styles[`alert-icon--danger`]}`}>
              <FiAlertCircle />
            </span>
            <div>
              <p style={{ marginBottom: 0 }}>
                <b>
                  Atenção:{' '}
                  {isProfessor
                    ? 'caso você discorde, atualize seus dados junto à gestão escolar por meio do sistema "Fala, Gestor!".'
                    : seducData?.['iseduc-finded']
                    ? 'caso você discorde, atualize seus dados junto à gestão escolar.'
                    : 'entre em contato com a gestão escolar para corrigir seus dados.'}
                </b>
              </p>
              {isProfessor ? '' : <p>Para continuar acessando os conteúdos de 2025, é só pedir para a gestão da sua escola atualizar seus dados.</p>}
            </div>
          </div>
          {isStudent && !seducData?.['iseduc-finded'] ? (
            <div className={styles.buttons}>
              <button
                className={`btn ${styles.btn}`}
                onClick={() => {
                  setShow(false);
                  updateVerifications('classroom-verified', false);
                  localStorage.setItem('verificated', false);
                }}
              >
                Vou entrar em contato com a gestão da minha escola
              </button>
            </div>
          ) : (
            <div className={styles.buttons}>
              {seducData?.['iseduc-finded'] && (
                <button
                  className={`btn ${styles.btn}`}
                  onClick={() => {
                    setShow(false);
                    syncClassrooms();
                  }}
                >
                  Meus dados estão corretos
                </button>
              )}
              <button
                className={`btn btn--outline`}
                onClick={() => {
                  setShow(false);
                  updateVerifications('classroom-verified', false);
                  localStorage.setItem('verificated', false);
                }}
              >
                Entrarei em contato com a gestão
              </button>
            </div>
          )}
        </div>
      )}
    </SimpleModal>
  );
}
